import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../components/ui/card";
import { useNavigate } from "react-router-dom";
import { API } from "../config";
import { Menu } from "../components/ui/menu";
import { useProfile } from "../context/ProfileContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { UsersTableRow } from "../components/ui/usersTableRow";
import { UsersTableRowSmall } from "../components/ui/usersTableRowSmall";
import Impersonate from "../components/ui/impersonate";
import { Button } from "../components/ui/button";

const fields: Record<string, string> = {
  "section": "СТ",
  "account": "Код НС2",
  "name": "ПІБ",
  "phones": "Телефон",
  "actions": "Дії"
}

type UserRecord = {
  roles?: string[];
  password?: string;
  section?: string;
  accounts?: {[key: string]: any};
  account?: string;
  name?: string;
  address?: string;
  phones?: {[key: string]: any};
}

export default function UsersPage() {
  const { profile, token } = useProfile();
  const [showLoading, setShowLoading] = useState<Boolean>(false);
  const [data, setData] = useState<any>(null);
  const [users, setUsers] = useState<any>(null);
  let initialState: string | null
  try {
    initialState = localStorage.getItem("users:query") || "";
  } catch (e) {
    console.error("Error reading query from localStorage:", e);
    initialState = ""; // Default to empty string if there's an error
  }
  const [query, setQuery] = useState<string>(initialState);
  const navigate = useNavigate();
  const [notification, setNotification] = useState<string>("");
  const [impersonateMessage, setImpersonateMessage] = useState<string>("");

  useEffect(() => {
    const impersonate = localStorage.getItem("impersonate");
    if (impersonate) {
      setImpersonateMessage(`Обліковий запис ${impersonate}`);
    }
  }, []);

  useEffect(() => {
    if (query && query.length > 2) {
      try {
        localStorage.setItem("users:query", query);
      } catch (e) {
        console.error("Error saving query to localStorage:", e);
      }
      const queries = query.split(" ").filter(q => q.trim() !== "");
      if (queries.length === 0) {
        setUsers({});
        return;
      }
      // Filter users based on the query
      let filteredUsers: Record<string, UserRecord> = data || {};

      // Apply each query to filter the users
      queries.map((currentQuery) => {
        currentQuery = currentQuery.toLowerCase();
        filteredUsers = Object.fromEntries(
          Object.entries(filteredUsers).filter(([key, user]) => {
            return String(user?.account)?.toLowerCase()?.includes(currentQuery)
              || String(user?.name)?.toLowerCase()?.includes(currentQuery)
              || String(user?.address)?.toLowerCase()?.includes(currentQuery)
              || String(user?.phones?.["main"])?.toLowerCase()?.includes(currentQuery);
          })
        );
      });

      // Convert back to an object (optional, based on your requirements)
      setUsers(filteredUsers);
    } else {
      if (query === "*") {
        setUsers(data || {});
      } else if (query === "0") {
        // Apply each query to filter the users
        let noTelephoneUsers: Record<string, UserRecord> = data || {};
        noTelephoneUsers = Object.fromEntries(
          Object.entries(noTelephoneUsers).filter(([key, user]) => {
            return String(user?.phones?.["main"]).trim() === ""
          })
        );

        // Convert back to an object (optional, based on your requirements)
        setUsers(noTelephoneUsers);
      } else if (query === "+") {
        // Apply each query to filter the users
        let noTelephoneUsers: Record<string, UserRecord> = data || {};
        noTelephoneUsers = Object.fromEntries(
          Object.entries(noTelephoneUsers).filter(([key, user]) => {
            return String(user?.password).trim() === "Y"
          })
        );

        // Convert back to an object (optional, based on your requirements)
        setUsers(noTelephoneUsers);
      } else if (query === "-") {
        // Apply each query to filter the users
        let noTelephoneUsers: Record<string, UserRecord> = data || {};
        noTelephoneUsers = Object.fromEntries(
          Object.entries(noTelephoneUsers).filter(([key, user]) => {
            return String(user?.password).trim() === "N"
          })
        );

        // Convert back to an object (optional, based on your requirements)
        setUsers(noTelephoneUsers);
      } else if (query === ".") {
        // Apply each query to filter the users
        let noTelephoneUsers: Record<string, UserRecord> = data || {};
        noTelephoneUsers = Object.fromEntries(
          Object.entries(noTelephoneUsers).filter(([key, user]) => {
            return user?.roles?.includes("ADMIN");
          })
        );

        // Convert back to an object (optional, based on your requirements)
        setUsers(noTelephoneUsers);
      } else {
        setUsers({});
      }
    }
  }, [query, data]);

  useEffect(() => {
    if (!token) {
      navigate("/login" + window.location.search);
      return;
    }

    try {
      setShowLoading(true);
      let cached = false
      let listOfUsersExpire: string | null = null;
      try {
        listOfUsersExpire = localStorage.getItem("users:expire");
      } catch (e) {
        console.error("Error reading users expire from localStorage:", e);
        listOfUsersExpire = null; // Default to null if there's an error
      }
      if (listOfUsersExpire && new Date(listOfUsersExpire) < new Date()) {
        try {
          localStorage.removeItem("users");
          localStorage.removeItem("users:expire");
        } catch (e) {
          console.error("Error removing users from localStorage:", e);
        }
      }

      let listOfUsers: string | null = null;
      try {
        listOfUsers = localStorage.getItem("users");
      } catch (e) {
        console.error("Error reading users from localStorage:", e);
        listOfUsers = null; // Default to null if there's an error
      }
      if (listOfUsers) {
        const usersData = JSON.parse(listOfUsers);
        setUsers({});
        setData(usersData);
        setTimeout(() => {
          setNotification("");
          setShowLoading(false);
        }, 1000);
      }

      if (!cached) {
        fetch(API.USERS, {
          headers: { Authorization: `Bearer ${token}` }
        })
          .then((res) => res.json())
          .then((data) => {
            try {
              localStorage.setItem("users", JSON.stringify(data?.users || {}));
              localStorage.setItem("users:expire", (new Date(Date.now() + 1000 * 60 * 60 * 0.5)).toISOString());
            } catch (e) {
              console.error("Error saving users to localStorage:", e);
            }
            setData(data?.users);
            setUsers({});
          }).finally(() => {
          setShowLoading(false);
        }).catch((err) => {
          console.log("Error fetching users:", err);
          setShowLoading(false);
        });
      }
    } catch (err) {
      console.log("Error fetching users:", err);
      setShowLoading(false);
    }
  }, [token, navigate]);


  if (showLoading) return <Menu><p className="text-center p-4">Завантажується...</p></Menu>;

  const editUser = (account?: string) => () => {
    if (account) navigate(`/user/${account}`);
  };

  const resetPasswordUser = (account?: string) => async () => {
    if (!token || !account) return;
    setNotification("Скідаємо пароль...");
    try {
      const res = await fetch(API.RESET_PASSWORD_USER(String(account)), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      if (res.ok) {
        if (users?.[account]?.password) {
          setUsers((prevUsers: any) => ({
            ...prevUsers,
            [account]: {
              ...prevUsers[account],
              password: "N", // Reset password to "N"
            },
          }));
        }
        setNotification(`Пароль скинутий для ${account}`);
        setTimeout(() => {
          setNotification("");
        }, 5000);
      } else {
        setNotification(data.error || "Не вдалося оновити");
        setTimeout(() => {
          setNotification("");
        }, 5000);
      }
    } catch (err) {
      setNotification(`Помилка сервера ${err}`);
      setTimeout(() => {
        setNotification("");
      }, 5000);
    }
  };

  const impersonateUser = (account?: string) => () => {
    if (!account) return;
    try {
      localStorage.setItem("impersonate", account);
    } catch (e) {
      console.error("Error saving impersonate to localStorage:", e);
    }
    setImpersonateMessage(`Обліковий запис ${account}`);
    setNotification(`Ви увійшли як ${account}`);
    setTimeout(() => {
      setNotification("");
      let page: string | null = "/profile";
      try {
        page = localStorage.getItem("page") ?? "/profile";
      } catch (e) {
        console.error("Error reading page from localStorage:", e);
        page = "/profile"; // Default to profile if there's an error
      }
      navigate(page)
    }, 1000);
  };

  return (
    <Menu>

      <div className="flex flex-col pr-2 pb-2">

        <Impersonate message={impersonateMessage} callbackExit={() => {
          try {
            localStorage.removeItem("impersonate");
          } catch (e) {
            console.error("Error removing impersonate from localStorage:", e);
          }
          setImpersonateMessage("");
          navigate("/users");
        }}/>

        {users && (
          <Card className="w-full max-w-fit rounded-2xl shadow-md">
            <CardContent className="">
              {notification && <p
                className="border border-gray-200 fixed top-5 left-1/2 transform -translate-x-1/2 bg-green-800 text-white px-6 py-3 rounded-lg shadow-lg z-50">{notification}</p>}
              <label className="block mb-2 text-sm font-medium text-gray-600">Пошук Користувача</label>
              <Button className="mb-1 mr-1" onClick={() => setQuery("*")}>Всі користувачі</Button>
              <Button className="mb-1 mr-1" onClick={() => setQuery(".")}>Всі Адміністратори</Button>
              <Button className="mb-1 mr-1" onClick={() => setQuery("0")}>Всі без телефону</Button>
              <Button className="mb-1 mr-1" onClick={() => setQuery("-")}>Всі без паролем</Button>
              <Button className="mb-1     " onClick={() => setQuery("+")}>Всі з паролем</Button>
              <div className="flex items-start">
                <div className="flex flex-row sm:w-1/2 w-full">
                  <input
                    autoFocus={true}
                    className="rounded-l-xl peer peer-focus w-full border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="118 9"
                    autoComplete="search"/>
                  <span className={"" +
                    "border border-gray-300 px-4 py-2" +
                    " peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-400"}>{Object.keys(users).length}</span>
                  <button
                    className={"peer " +
                      " bg-blue-700 text-gray-700 border border-gray-300 rounded-r-xl" +
                      " px-4 py-2 hover:bg-blue-300" +
                      " peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-400 peer-focus-within:bg-blue-500"}
                    onClick={() => {
                      setQuery("");
                      setTimeout(() => {
                        setQuery(() => query);
                      }, 10);
                      return;
                    }}
                  >
                    <FontAwesomeIcon color={"white"} icon={faSearch}/>
                  </button>
                </div>
              </div>
              <div className="hidden sm:block w-full">
                <table className="text-xs w-full table-fixed border-collapse border border-gray-200 border-slate-500">
                  <thead className="bg-gray-100 text-gray-700 font-semibold">
                  <tr className="text-gray-900">
                    <th className="w-1/6 px-2 py-2 border border-gray-200 text-center">#</th>
                    <th className="w-1/4 px-4 py-2 border border-gray-200 text-left break-words">СТ</th>
                    <th className="w-1/3 px-4 py-2 border border-gray-200 text-left break-words">Код НС2</th>
                    <th className="w-1/3 px-4 py-2 border border-gray-200 text-left break-words">ПІБ<br/>Адреса</th>
                    <th className="w-1/2 px-4 py-2 border border-gray-200 text-left break-words">Телефон</th>
                    <th className="w-1/6 px-4 py-2 border border-gray-200 text-left break-words">Дії</th>
                  </tr>
                  </thead>
                  <tbody>
                  {Object.entries(users).map(([key, user]: [string, any], index) =>
                    <UsersTableRow key={key ?? "user-" + index + Math.random()}
                                   index={index}
                                   user={user}
                                   admin={profile}
                                   editUser={editUser}
                                   resetPasswordUser={resetPasswordUser}
                                   impersonateUser={impersonateUser}/>)}
                  </tbody>
                </table>
              </div>
              <div className="block sm:hidden w-full">
                <table className="text-xs w-full table-fixed border-collapse border border-gray-200 border-slate-500">
                  <thead className="bg-gray-100 text-gray-700 font-semibold">
                  <tr className="text-gray-900">
                    <th className="w-1/6 px-2 py-2 border border-gray-200 text-center">#<br/>СТ</th>
                    <th className="w-1/2 px-4 py-2 border border-gray-200 text-left break-words">Код НС2<br/>ПІБ<br/>Телефон
                    </th>
                    <th className="w-1/6 px-4 py-2 border border-gray-200 text-left break-words">Дії</th>
                  </tr>
                  </thead>
                  <tbody>
                  {Object.entries(users).map(([key, user]: [string, any], index) =>
                    <UsersTableRowSmall key={key}
                                        index={index}
                                        user={user}
                                        admin={profile}
                                        editUser={editUser}
                                        resetPasswordUser={resetPasswordUser}
                                        impersonateUser={impersonateUser}/>)}
                  </tbody>
                </table>
              </div>

            </CardContent>
          </Card>
        )}
      </div>
    </Menu>
  );
}
